<div class="modal-header">
    <h4 class="modal-title">Detalles del Concepto</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="form">
        <div class="form-group">
            <label for="nombre">Nombre</label>
            <input type="text" class="form-control" id="nombre" formControlName="nombre"
                [ngClass]="{'is-invalid': form.controls['nombre'].errors && form.controls['nombre'].touched}">
            <div class="invalid-feedback">
                Debe ingresar un valor en el campo.
            </div>
            <div class="mb-4" *ngIf="!form.controls['nombre'].errors || !form.controls['nombre'].touched">
            </div>
        </div>
        <div class="form-group">
            <label for="descripcion">Descripción</label>
            <textarea class="form-control" id="descripcion" rows="6" formControlName="descripcion"></textarea>
        </div>

    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Cancel click')">Cerrar</button>
</div>